import { Modal, Text, ButtonGroup, Button } from '@nike/eds';
import { useState } from 'react';

type RankingListPreviewProps = {
  item: RankingList | null;
  publishOpen: boolean;
  submitStatus: boolean;
  closePublishModal: () => void;
  publishRankById: () => void;
};
export default function RankingListPublish(props: RankingListPreviewProps) {
  const {
    item,
    publishOpen,
    submitStatus,
    closePublishModal,
    publishRankById,
  } = props;
  const title = props?.item?.title;
  return (
    <>
      <Modal
        headerSlot={'Publish Rank'}
        isOpen={props.publishOpen}
        onDismiss={() => {
          closePublishModal();
        }}
      >
        <Text className='tw-font-bold'>{title}</Text>
        <Text className='tw-mt-2 '>
          Are you sure you want to publish this Rank?
        </Text>
        <Text className='tw-mt-2'>
          This operation will immediately take effect.
        </Text>
        <ButtonGroup className='tw-justify-end tw-pt-6'>
          <Button
            disableRipple
            disabled={submitStatus}
            onClick={() => {
              publishRankById();
            }}
            size='medium'
          >
            Publish
          </Button>
          <Button
            disableRipple
            onClick={() => {
              closePublishModal();
            }}
            size='medium'
            variant='secondary'
          >
            Cancel
          </Button>
        </ButtonGroup>
      </Modal>
    </>
  );
}
